<template>
  <div class="multi-functionImg">
    <!-- 文件上传框 -->
    <el-col :style="{ width }" class="upload-item marRight20">
      <div :class="{'borderRed' : isUploadError }" :style="{ width, height }" :title="fileName + fileNameInfo"
           class="up-box">
        <div v-if="!readonly && fileUrl && (((typeof fileUrl) === 'string' && fileUrl) || ((typeof fileUrl) === 'object' && fileUrl.length !== 0 ))"
             class="up-function">
                    <span class="icon-container">
                    <!--<i class="cropper-icon pointer" title="裁剪" @click.stop="openCropper"></i>-->
                    <i class="pointer del el-icon-delete size16 colorBB marLeft5" title="删除" @click.stop="delImg"></i>
                    </span>
        </div>
        <div v-show="imgShowBold" class="img-box pointer XYcenter" @click.stop="openViewer(fileUrl, fileName)">
          <img :src="imgShowBold"/>
        </div>

        <div v-show="!imgShowBold" class="upbox-b">
          <div v-show="!isLoading" :class="{'bottom5': fileName}" class="cross"></div>
          <i v-show="isLoading" class="el-icon-loading loading-icon color26"></i>
          <div v-show="false" class="text">
            <p :class="{'must-write': required}" class="size12 color99">{{ fileName }}</p>
            <p class="size12 colorG">{{ fileNameInfo }}</p>
          </div>
        </div>
        <input v-if="!readonly" ref="uploadInput" :accept="accept" :multiple="isMultiple" type="file"
               @change="filesUpFn($event)"/>
      </div>
      <div v-show="fileName || showFileName" :style="{ width }" class="size12 color99 textCenter h32"
           style="margin-top: 5px;">
        <span v-if="showFileName" :class="{'must-write': required}">{{ showFileName }}</span>
        <span v-else :class="{'must-write': required}">{{ fileName }}</span> <span
          class="size12 colorG">{{ fileNameInfo }}</span>
        <div v-if="exampleUrl" class="textCenter">
          <span class="pointer color26" @click="openViewer(exampleUrl,`${fileName}示例文件`)"><i
              class="iconfont icon-sousuo size14"></i><span> 查看示例</span></span>
        </div>
        <!-- 下载模板 -->
        <div v-if="moduleUrl" class="textCenter">
                    <span class="pointer color26" @click="openViewer(moduleUrl, moduleName)">
                       <i class="iconfont icon-xiazai size14"></i><span> {{ moduleName }}</span>
                    </span>
        </div>
        <!-- 修改等自定义功能 -->
        <el-row v-if="btnOtherClick"><span class="pointer color26" target="_blank"
                                           @click="btnOtherFn">{{ btnName }}</span></el-row>
      </div>
    </el-col>

    <!--查看大图组件-->
    <image-review v-if="viewerShow" ref="review" :imgId="imgId" :imgIdList="imgIdList"></image-review>

    <!--  显示上传进度    -->
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="showProgress"
        append-to-body
        title="大文件上传进度"
        width="768px">

      <el-row>
        <el-col :span="24">
      <el-progress :percentage="percentage" :stroke-width="26" :text-inside="true"></el-progress>
        </el-col>
      </el-row>
      <el-row style="padding: 15px;">
        <el-col :span="8">文件大小:<span class="tipsTxt">{{bigFileSize}}</span></el-col>
        <el-col :span="8">速度:<span class="tipsTxt">{{upSpeed}}</span></el-col>
        <el-col :span="8">剩余时间:<span class="tipsTxt">{{leftTime}}</span></el-col>
      </el-row>
    </el-dialog>

  </div>


</template>
<script>
import imageReview from '../imageReview' //查看大图组件
var self;
var ot;//
var oloaded;
export default {
  name: 'upload-file',
  props: {
    fileUrl: {  // 必填,可传空，注意要加修饰符sync  如:fileUrl.sync=变量
      // type: [String, Array,],
      default: () => {
        return ''
      },
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    id: {
      type: String,
      default: ''
    },
    showFileName: {
      type: String,
      default: ''
    },
    fileName: { // 文件框下显示的文件名
      type: String,
      default: ''
    },
    fileAlias: { // 上传文件时给后端的别名，如果有fileName优先fileName
      type: String,
      default: ''
    },
    fileNameInfo: { // 文件名盘边的绿色小字，类似于备注
      type: String,
      default: ''
    },
    exampleUrl: { // 示例文件地址，支持下载
      type: String,
      default: ''
    },
    moduleUrl: { // 模板文件地址，支持下载
      type: String,
      default: ''
    },
    moduleName: {
      type: String,
      default: '模板名称'
    },
    required: { // 是否必填
      type: Boolean,
      default: false
    },
    accept: { // 上传的文件类型
      type: String, // text/plain, application/zip
      default: '*'
    },
    isMultiple: { // 是否多选, multiple
      type: Boolean,
      default: false
    },
    readonly: { // 只读，详情时用到
      type: Boolean,
      default: false
    },
    btnName: {
      type: String,
      default: '查看示例'
    },
    btnOtherClick: { // 查看示例的按钮 改装
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '150px'
    },
    height: {
      type: String,
      default: '150px'
    }
  },
  components: {
    imageReview,

  },
  created() {
    self = this
  },
  data() {
    return {
      apiUrl: `${process.env.FILE_SERVICE}/Admin/UploadFiles`, // 上传地址
      imgApiUrl: `${process.env.FILE_SERVICE}/Admin`, // 获取图片流
      isUploadError: false,
      imgShowBold: '',
      imgIdList: [],
      imgId: '',
      fileInfos: [],
      viewerShow: true,//查看大图销毁
      isLoading: false,
      pdfDialog: true,
      pdfsrc: '',
      bigFileMode: false,
      showProgress: false,
      percentage: 0,
      upSpeed:'',
      leftTime:'',
      bigFileSize:'',
    }
  },
  watch: {
    fileUrl: {
      handler(val) {
        if (val == null) val = ''
        let imgIds = []
        if (val.indexOf(',') !== -1) {
          imgIds = val.split(',')
          imgIds.forEach(item => {
            this.init(item)
          })
        } else {
          this.init(val)
        }
      },
      immediate: true
    },
  },
  methods: {
    btnOtherFn() {
      this.$emit('btnOtherFn')
    },
    delImg() {
      this.$emit('ddel')
      this.$refs['uploadInput'].value = ''
      this.imgShowBold = ''
      this.isLoading = false
      this.$emit('update:fileUrl', '')
    },
    init(val) {
      if (!val) {
        this.imgShowBold = ''
        this.$nextTick(() => {
          if (this.$refs['uploadInput']) this.$refs['uploadInput'].value = ''
        })
        return
      }
      if ((typeof val) === 'string') {
        this.getImgBoldFn(val, bold => {
          this.imgShowBold = bold
          this.isLoading = false
        }); // 获取图片流显示
      } else if (val.length > 0) {
        this.imgShowBold = require('@/assets/image/file.png')
        this.isLoading = false
      }
    },
    // 图片上传组件 值包含多张图片 特殊处理
    imgArrFn(imgId, imgType, name, imgIdList) {
      const hz = '.' + imgId.split('.')[1]
      if (imgType.indexOf(hz) !== -1) {
        let img = {
          id: imgId,
          name: name
        }
        imgIdList.push(img)
        this.imgId = imgId
        this.imgIdList = imgIdList
        this.$refs.review.show()
      } else {
        let url = `${this.imgApiUrl}/${imgId}`
        if (imgId.indexOf('modelfiles') !== -1) { // 模板文件地址 处理
          let fileTypeAry = imgId.split('/')
          url = `${this.imgApiUrl}/ModelFile/${fileTypeAry[fileTypeAry.length - 1]}`
        }
        this._ajaxFn(url, 'GET').then(res => {
          this.utils.Export(res, (name + hz))
        }).catch(error => {
          this.$message({type: 'error', message: '下载失败'})
        });
      }
    },
    //查看大图
    openViewer(imgId, name) {
      let imgIds = [], imgIdList = []
      const imgType = ['.jpg', '.png', '.jpeg', '.JPG', '.PNG', '.JPEG', '.pdf']
      if (typeof imgId === 'string') {
        if (imgId.indexOf(',') !== -1) {
          imgIds = imgId.split(',')
          this.imgIdList = []
          imgIds.forEach(item => {
            this.imgArrFn(item, imgType, name, this.imgIdList)
          })
        } else {
          this.imgArrFn(imgId, imgType, name, imgIdList)
        }
      } else if (imgId && imgId.length) { // 如果是一个数组。遍历下载
        imgId.forEach((it, index) => {
          setTimeout(() => {
            const hz = '.' + it.split('.')[1]
            let url = `${this.imgApiUrl}/${it}`
            if (it.indexOf('modelfiles') !== -1) { // 模板文件地址 处理
              let fileTypeAry = it.split('/')
              url = `${this.imgApiUrl}/ModelFile/${fileTypeAry[fileTypeAry.length - 1]}`
            }
            this._ajaxFn(url, 'GET').then(res => {
              this.utils.Export(res, (`${name}_${index + 1}${hz}`))
            }).catch(error => {
              this.$message({type: 'error', message: '下载失败'})
            })
          }, 100)
        })
      }
    },
    filesUpFn(el) {
      let is5M = false
      let fileNames = []
      var fileObj = el.currentTarget.files;
      let hasFile = false
      if (fileObj[0].type == "") {
        hasFile = true
        if (fileObj[0].name.indexOf('.rar') != -1) {
          hasFile = false
        }
      }
      //console.log(this.accept)
      if ((!fileObj || fileObj.length === 0) || hasFile) {
        this.isUploadError = true
        this.$message.error('请选择文件')
        return
      } else {
        this.isUploadError = false
      }

      let isCanUpload = false
      for (let i = 0; i < fileObj.length; i++) {
        fileNames.push(fileObj[i].name)
        let file = fileObj[i]
        if (file.size / 1024 / 1024 > 5) {
          is5M = true
        }
        if (file.size / 1024 / 1024 > 20) { // 当有一个文件大于20M的话
          this.bigFileMode = true
          console.log("bigFile:", file.name, ',size:', file.size / 1024 / 1024, 'M')

          self.bigFileSize = (file.size / 1024 / 1024).toFixed(2)+'M'

        } else {
          this.bigFileMode = false
        }
        if (file.size / 1024 / 1024 > 200) { // 当有一个文件大于500M的话
          isCanUpload = true
          break;
        }
      }
      //console.log(fileNames)
      this.$emit('fileSize', is5M)
      this.$emit('fileName', {id: this.id, fileNames})
      if (isCanUpload) return this.$message.error('上传文件大小不能超过 200MB!')

      this.imgShowBold = ''
      this.isLoading = true
      var data = new FormData();
      data.append("action", "UploadVMKImagePath");
      if (this.fileName) {
        data.append("fileAlias", this.fileName);
      } else if (this.fileAlias) {
        data.append("fileAlias", this.fileAlias);
      }
      this.fileInfos = []
      for (let i = 0; i < fileObj.length; i++) {
        this.fileInfos.push({  // 保存上传的文件名
          originalFileName: fileObj[i].name,
          filePath: ''
        })
        data.append("file", fileObj[i]); // 加入文件对象
      }
      this._ajaxFn(this.apiUrl, 'POST', data).then(resp => {
        const data = JSON.parse(resp)
        this.isUploadError = false;

        if (this.isMultiple) {
          console.log(this.fileUrl)
          this.$emit('update:fileUrl', data)
          this.$emit('uploadSuccess', data)
          this.$emit('fileInfos', this.fileInfos)
        } else {
          this.$emit('update:fileUrl', data[0])
          this.$emit('uploadSuccess', data[0])
          this.$emit('fileInfos', this.fileInfos)
        }
      })
    },
    _ajaxFn(url, method, data) {
      if (this.bigFileMode) {
        console.log('bigFileMode is working')
        url = 'https://goapi.vesaas.cn/fileService/Admin/UploadFiles'
      }


      return new Promise((reslove, reject) => {
        var xhr = new XMLHttpRequest();
        if (this.bigFileMode) {
          xhr.upload.onprogress = self.progressFunction;//【上传进度调用方法实现】
          xhr.upload.onloadstart = function () {//上传开始执行方法
            self.showProgress = true
            self.percentage = 0
            ot = new Date().getTime();   //设置上传开始时间
            oloaded = 0;//设置上传开始时，以上传的文件大小为0
          };
        }

        xhr.open(method, url, true);
        // 添加http头，发送信息至服务器时内容编码类型
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.setRequestHeader('authorization', `Bearer ${localStorage['accessToken']}`);
        if (!data) {
          xhr.responseType = 'blob'
        }
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4) {
            if (xhr.status == 200 || xhr.status == 304) {
              self.showProgress = false
              reslove(xhr.response);
            } else {
              this.$message.error('上传失败，请重新上传！')
            }
          }
        }
        xhr.send(data);
      })
    },
    //上传进度实现方法，上传过程中会频繁调用该方法
    progressFunction(evt) {


      // event.total是需要传输的总字节，event.loaded是已经传输的字节。如果event.lengthComputable不为真，则event.total等于0
      if (evt.lengthComputable) {//
        self.percentage = Math.round(evt.loaded / evt.total * 100)
      }

      var nt = new Date().getTime();//获取当前时间
      var pertime = (nt - ot) / 1000; //计算出上次调用该方法时到现在的时间差，单位为s
      ot = new Date().getTime(); //重新赋值时间，用于下次计算

      var perload = evt.loaded - oloaded; //计算该分段上传的文件大小，单位b
      oloaded = evt.loaded;//重新赋值已上传文件大小，用以下次计算

      //上传速度计算
      var speed = perload / pertime;//单位b/s
      var bspeed = speed;
      var units = 'b/s';//单位名称
      if (speed / 1024 > 1) {
        speed = speed / 1024;
        units = 'k/s';
      }
      if (speed / 1024 > 1) {
        speed = speed / 1024;
        units = 'M/s';
      }
      speed = speed.toFixed(1);
      //剩余时间
      var resttime = ((evt.total - evt.loaded) / bspeed).toFixed(1);
      self.upSpeed = speed + units
      self.leftTime = resttime + 's';

      if (bspeed === 0)self.upSpeed = '上传已取消';
    },
    getImgBoldFn(value, callBack) {
      if (!value || value == null) return false;
      if (value.indexOf('.zip') != -1 || value.indexOf('.rar') != -1) {
        callBack(require('@/assets/image/zip.png'));
      } else if (value.indexOf('.txt') != -1) {
        callBack(require('@/assets/image/txt.png'));
      } else if (value.indexOf('.pdf') != -1) {
        callBack(require('@/assets/image/pdf.png'));
      } else if (value.indexOf('.doc') != -1 || value.indexOf('.docx') != -1) {
        callBack(require('@/assets/image/word.png'));
      } else if (value.indexOf('.jpg') != -1 || value.indexOf('.png') != -1 || value.indexOf('.jpeg') != -1 || value.indexOf('.JPG') != -1 || value.indexOf('.PNG') != -1 || value.indexOf('.JPEG') != -1) {
        let url = `${this.imgApiUrl}/${value}`
        if (value.indexOf('modelfiles') !== -1) { // 模板文件地址 处理
          let fileTypeAry = value.split('/')
          url = `${this.imgApiUrl}/ModelFile/${fileTypeAry[fileTypeAry.length - 1]}`
        }

        this._ajaxFn(url, 'GET').then(resp => {
          console.log(resp)
          callBack(window.URL.createObjectURL(resp));
        }).catch(e => {
          // callBack("./static/img/lost.png");
        });
      } else {
        callBack(require('@/assets/image/file.png'));
      }
    },
    filesDownload(url, name) {
      // let root = '/modelfiles/CBC55A168F374CAD81BF2AE1341FBF52.zip' // 注册代理授权书 线上地址
      // let root ='/modelfiles/8D8372B1EE864ECE9F89B2EFA6E07A3F.zip' //注册代理授权书 测试地址
      let hz = '.' + url.split('.')[1]
      let _url = `${process.env.VUE_APP_API_FILE_SERVICE}/StaticFiles${url}`;
      this.filesDownloadBya(_url, (name + hz));
    },
    /*
    * todo 普通文件下载
    * */
    filesDownloadBya(url, name) {  //文件下载方法
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a');
        elink.download = name;
        elink.style.display = 'none';
        elink.href = url;
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href);// 释放URL 对象
        document.body.removeChild(elink);
      } else { // IE10+下载
        navigator.msSaveBlob(url, name);
      }
    }
  }
}
</script>
<style scoped>
.tipsTxt{font-weight: bold;color: #409EFF;}
li {
  list-style: none;
}

* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-style: normal;
  font-family: '微软雅黑', "microsoft yahei", Helvetica, Arial, sans-serif;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.size12 {
  font-size: 12px;
}

.colorDC {
  color: #DCDFE6
}

.color99 {
  color: #999999;
}

.colorG {
  color: #2BA345
}

.XYcenter { /*垂直水平居中*/
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.textCenter {
  text-align: center
}

.width150 {
  width: 150px
}

/* 必填项的星号 */
.must-write::before {
  content: ' * ';
  color: #FD483F;
  font-size: 100%;
}

.upload-item .up-box {
  width: 150px;
  height: 150px;
  padding: 3px;
  border: 1px dashed #DCDFE6;
  box-sizing: border-box;
  position: relative;
  border-radius: 8px;
}

.upload_wh60 .upload-item .up-box {
  width: 60px;
  height: 60px;
}

.upload-item .up-box .text {
  text-align: center;
  height: 45px;
}

.input_error .upload-item .up-box {
  border-color: #f56c6c !important;
}

.input_error .cross:before, .input_error .cross:after {
  background: #f56c6c !important;
}

.upload-item .up-box .text p {
  line-height: 20px;
}

.upload-item .up-box .img-box {
  width: 100%;
  height: 100%;
}

.upload-item .up-box img {
  max-height: 100%;
  max-width: 100%;
  position: relative;
  z-index: 1;
}

.upload-item .up-box .upbox-b {
  padding: 10px;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
}

.upload-item .up-box .cross {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
}

.upload-item .loading-icon {
  position: absolute;
  font-size: 26px;
}

.bottom5 {
  bottom: -5px;
}

.up-box input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

.upload-item .borderRed {
  border: 2px #f56c6c dashed !important;
}

.h32 {
  line-height: 20px;
}

/* 十字架实现 */
.cross:before, .cross:after {
  content: "";
  position: absolute;
  background: #DCDFE6;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.cross:before {
  width: 45px;
  height: 1px;
}

.cross:after {
  width: 1px;
  height: 45px;
}

.up-function .icon-container {
  position: absolute;
  right: 5px;
  top: 3px;
  display: flex;
  z-index: 2;
}

.up-function .cropper-icon {
  width: 16px;
  height: 16px;
  display: inline-block;
  z-index: 2;
  transition: .3s;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAcUlEQVQ4T62SUQ7AIAhD5+E4NYdzYQlJVdTi9E9DH21jeX6egnpVrXYXkeY92mGzNncEcLGBP4BvZtOgwzsA37zqAF0ODnYAzxwt2JaIhaUBKMayqQi9OAWYfSY6QuY/hCUeAaLMPWgagRFTJbLWce4Ff3RwETf02BoAAAAASUVORK5CYII=) 50% center no-repeat;
}

.up-function .cropper-icon:hover {
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAdUlEQVQ4T2NkoBAwIutXa/z3H8S/Vc+EIo7NDpBakDqyDIBpBhkMNgBmM7G+QXYhdQyA2YwvDJBdieECQgbA/IzNAoKBiBxgJBuArBk5sInyArpmkgzAlZiI9gIp6QFrIJJlADY/oxuE0wvEaCYqEIl1OrI6ALqFcBGdflDbAAAAAElFTkSuQmCC) 50% center no-repeat;
}

.up-function .el-icon-delete {
  transition: .3s;
}

.up-function .el-icon-delete:hover {
  color: #FD483F;
}

.upload_wh60 .up-box {
  width: 60px !important;
  height: 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadFile/UploadFile.vue